var Renderable =
/** @class */
function () {
  function Renderable() {
    this.boundsDirty = true;
    this.renderBoundsDirty = true;
    /**
     * dirty rectangle flag
     */

    this.dirty = false;
  }

  Renderable.tag = 'c-renderable';
  return Renderable;
}();

export { Renderable };